import { gql } from '@apollo/client';

export const FileFields = gql`
  fragment FileFields on FileFieldType {
    name
    url
  }
`;

export default FileFields;
